<template>
    <!-- Only show 3 items in the autocomplte -->
    <div class="autocomplete-container">
        <v-autocomplete
            v-model="selectedCountry"
            v-model:search="search"

            :items="filteredCountries"
            label="Search"
            item-title="country_name"
            item-value="country_object_code"
            no-data-text="No matching countries"
            
            prepend-inner-icon="mdi-magnify"
            :menu-props="{ maxHeight: 150}"

            :class="focused ? 'autocomplete-focused' : 'autocomplete'"

            @update:menu="focused = !focused"

            variant="solo"
            flat        
        >
            <template v-slot:chip="{ props, item }">
                <v-chip
                    v-bind="props"
                    :prepend-avatar="getFlagUrl(item)"
                    :text="item.raw.name"                
                ></v-chip>
            </template>

            <template v-slot:item="{ props, item }">
                <v-list-item
                    class="listItem"
                    v-bind="props"
                    :prepend-avatar="getFlagUrl(item)"
                    :title="item.raw.country_name"
                    @click="selectedCountry = item"
                ></v-list-item>
            </template>
        </v-autocomplete>
    </div>
</template>

<script>
// TODO the boarders are not quite right
import {Service as CountryService} from '../../services/countryService';
import store from '@/store';
export default {
    name: 'CountryAutocomplete',
    data() {
        return {
            selectedCountry: null,
            countries: [],
            maxResults: 3,
            search: '',
            isMobile: window.innerWidth <= 900,
            focused: false
        };
    },
     mounted() {
            this.loadCountries();
            this.countries.sort((a, b) => a.country_name.localeCompare(b.country_name));
    },
    created() {
        // window.addEventListener('resize', this.handleResize);
    },
    methods: {
         loadCountries() {
           // const allCountriesModule = await import('@/data/allCountryData.json');
           
            const allCountries =  CountryService.getAllCountries();
            
            this.countries = allCountries.map(country => ({
                country_name: country.country_name,
                country_code: country.country_object_code.toLowerCase(),
            }));
        },
        getFlagUrl(country) {
            
            try {
                const countryCode = country.raw.country_code;
                return require(`@/assets/flags/${countryCode.toLowerCase()}.svg`);
            } catch (e) {
                // console.error('Error getting flag url', e);
                return require('@/assets/flags/unknown.svg');
            }
        }
    },
    computed: {
        
        filteredCountries() {
            return this.countries;
        },
        storedCountries() {
            return store.getters['countryStoreData/allCountries'];
        }
    },
    watch: {
        selectedCountry: {
            immediate: true,
            handler(val) {
                if (val) {

                    this.$emit('selectedCountry', val.raw.country_code.toUpperCase());   
                    this.selectedCountry = null;                 
                }
            }
        },
        storedCountries: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.loadCountries();
                    this.countries.sort((a, b) => a.country_name.localeCompare(b.country_name));
                }
            }
        }

    }
};
</script>

<style>
.autocomplete-container {
    /* max-width: 600px; */
    /* margin: 0 auto; */
    position: absolute;
    top: 45%;
    left: 2%;
}

.autocomplete-focused .v-input__control .v-field{
    border-radius:5px 5px 0 0;
    /* border: 1px solid #ff0000; */
}

/* .autocomplete-container  .autocomplete .v-input__control{
    background: none  !important;
} */

/* .autocomplete-container  .autocomplete .v-input__control>div{
    border: 1px solid #9DA3AE;
    border-radius: 10px;
    background-color: white;
} */
/* 
.autocomplete-container .autocomplete-focused .v-input__control>div{
    border: 1px solid #ff0000;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-top-left-radius: 10px  !important;
    border-top-right-radius: 10px !important;
    background-color: white;
} */

/* .autocomplete .v-input__control {
    border-radius: 8px;
} */

/* .autocomplete-container .v-field__overlay{
    border-radius: 9px !important;    
    background: white !important;
    opacity: 0;
} */

/* .autocomplete-container .v-input__control{
    background-color: white;
    border-bottom-right-radius:0px ;
    border-bottom-left-radius:0px ;    
}

.autocomplete-container .listItem img{
        border-radius: 0!important;
} */

/* v-theme--light v-avatar--density-default v-avatar--size-default v-avatar--variant-flat */
.v-avatar.v-avatar--variant-flat {
    max-width: 20px !important;
    max-height: 20px !important;
}

/* .autocomplete .v-field__outline{
    display: none;
} */

/* remove rounded border from overlay */
/* .v-input__control .v-field__overlay{
    border-radius: 0px !important;
    background: white !important;
    opacity: 0;
} */

/* Remove shadow from the autocomplete dropdown */
/* .v-overlay-container >* {
    box-shadow: none !important;
} */


/* Ensure the dropdown stays open for debugging */
/* .v-menu__content {
    pointer-events: all;
    visibility: visible !important;
    opacity: 1 !important;
    display: block !important;
} */

.v-autocomplete__content {
    width: 300px;
    padding-top: 0px;
    position: relative;
    border-top-right-radius: 0 !important;
    border-top-left-radius: 0 !important;
    box-shadow: none;
}

.v-autocomplete__content::before {
    content: "";
    margin-left: 10%;
    margin-right: 10%;
    border-bottom: 1px solid #9DA3AE;
    margin-bottom: -1px;
    z-index: 100000;
}

.v-autocomplete__content>div{
    /*  */
}
/*  Media Queries */
/* mobile */
@media (max-width: 900px) {
    .autocomplete-container {
        width: 90%;
        left: 5%;
        top: 5%;
        height: 50px;
    }

    .autocomplete-container .v-input__control{
        border-radius: 1em;
        border: 1px solid #e0e0e0;    
    }
}

/* desktop */
@media (min-width: 900px) {
    .autocomplete-container {
        width: 300px;
        left: 2%;
        top: 45%;
    }
}

</style>
